import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import { Observable } from 'rxjs';
import {AuthService} from "../../features/components/auth/auth.service";

@Injectable({
    providedIn: 'root'
})
export class UserRouteAccessGuard implements CanActivate {

    constructor(private readonly authService: AuthService,private readonly router: Router) {}

    canActivate(route: ActivatedRouteSnapshot,state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (this.authService.isTokenExpired()) {
            this.router.navigate(['/auth/login']);
            return false;
        }

        const expectedRoles = route.data['authorities'] as Array<string>;
        const userRole = [this.authService.getLocalUser()?.role?.libelle]
        
        if (expectedRoles && !expectedRoles.some(role => userRole?.includes(role))) {
            this.router.navigate(['/unauthorized']);
            return false;
        }

        return true;
    }
}
